// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal","modal":"Modal","Modal--open":"Modal--open","modalOpen":"Modal--open","Modal__Content":"Modal__Content","modalContent":"Modal__Content","Modal__Content--open":"Modal__Content--open","modalContentOpen":"Modal__Content--open","Modal__ExitBtn":"Modal__ExitBtn","modalExitBtn":"Modal__ExitBtn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 461
// module chunks = 0